import * as CryptoJS from 'crypto-js';

export const cryptoConstants = {
  key: CryptoJS.enc.Utf8.parse('4512631236589784'),
  iv: CryptoJS.enc.Utf8.parse('4512631236589784'),
};